export default "__VITE_ASSET__DzmqDf0C__"